import {
  DETECTING_OUT_OF_STOCK_PENDING,
  DETECTING_OUT_OF_STOCK_REJECTED,
  DETECTING_OUT_OF_STOCK_FULFILLED
} from "../constants/detectingOutOfStock";

const initialState = {
  pending: false,
  detectingOutOfStockResponse: {},
  error: {}
};

export const detectingOutOfStock = (state = initialState, action) => {
  switch (action.type) {
    case DETECTING_OUT_OF_STOCK_PENDING:
      return { ...state, pending: true, error: {} };

    case DETECTING_OUT_OF_STOCK_REJECTED:
      return {
        ...state,
        pending: false,
        error: action.error
      };

    case DETECTING_OUT_OF_STOCK_FULFILLED:
      return {
        ...state,
        detectingOutOfStockResponse: action.response.data,
        pending: false,
        error: {}
      };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/detectingOutOfStock.js